import { Component, Input } from '@angular/core';
@Component({
    selector: 'vw-ai-chatbot-willy',
    imports: [],
    templateUrl: './ai-chatbot-willy.component.html',
    styleUrl: './ai-chatbot-willy.component.scss'
})
export class AiChatbotWillyComponent {
    @Input() action: 'hi' | 'thinking' | 'explaining' | 'dontknow' = 'hi';
}
